import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const initialState = {
  id: "",
  name: "",
  email: "",
  phoneNumber: "",
  designation: "",
  permission: [
    {
      name: "Dashboard",
      read: false,
      fullAccess: false,
    },
    {
      name: "Student",
      read: false,
      fullAccess: false,
    },
    {
      name: "Feed",
      read: false,
      fullAccess: false,
    },
    {
      name: "Category",
      read: false,
      fullAccess: false,
    },
    {
      name: "Courses",
      read: false,
      fullAccess: false,
    },
    {
      name: "Podcasts",
      read: false,
      fullAccess: false,
    },
    {
      name: "Challenges&Bounty",
      read: false,
      fullAccess: false,
    },
    {
      name: "Livestream",
      read: false,
      fullAccess: false,
    },
    {
      name: "Payment",
      read: false,
      fullAccess: false,
    },
    {
      name: "Sub-Admin",
      read: false,
      fullAccess: false,
    },
    {
      name: "Notification",
      read: false,
      fullAccess: false,
    },
    {
      name: "Static-Content",
      read: false,
      fullAccess: false,
    },
  ],
};
const ViewSubAdmin = () => {
  const [iState, setUpdateState] = useState(initialState);
  const { name, email, phoneNumber, designation, permission, id } = iState;
  const { state } = useLocation();

  useEffect(() => {
    setUpdateState({
      id: state?._id,
      name: state?.name,
      email: state?.email,
      phoneNumber: state?.phoneNumber,
      designation: state?.designation,
      permission: [...state?.permission],
    });
  }, []);
  const handleCheck = () => {};
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Sub-Admin Details</h4>
          </div>
          <div className="CommonForm">
            <div className="row">
              <div className="col-lg-3">
                <div className="form-group">
                  <label>Name</label>
                  <p>{name}</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label>Phone No.</label>
                  <p>{phoneNumber}</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label>Email ID</label>
                  <p>{email}</p>
                </div>
              </div>
              <div className="col-lg-3">
                <div className="form-group">
                  <label>Role</label>
                  <p>{designation}</p>
                </div>
              </div>
            </div>
          </div>
          <div className="TitleBox Border mt-4">
            <h4 className="Title">Sub-Admin Rights Access</h4>
          </div>
          <fieldset disabled="">
            <div className="TableList BorderTop">
              <table className="table">
                <tbody>
                  {permission.map((res) => {
                    return (
                      <tr>
                        <td style={{ borderTop: "none" }}>
                          <strong>{res?.name}</strong>
                        </td>
                        <td style={{ borderTop: "none" }}>
                          <label className="CheckBox">
                            {" "}
                            Read
                            <input
                              type="checkbox"
                              name="read"
                              checked={res?.read}
                              onChange={(e) => handleCheck(e, res?.name)}
                            />
                            <span className="checkmark" />
                          </label>
                        </td>
                        <td style={{ borderTop: "none" }}>
                          <label className="CheckBox">
                            {" "}
                            Full Access
                            <input
                              type="checkbox"
                              name="fullAccess"
                              checked={res?.fullAccess}
                              onChange={(e) => handleCheck(e, res?.name)}
                            />
                            <span className="checkmark" />
                          </label>
                        </td>
                        <td style={{ borderTop: "none" }} />
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </fieldset>
        </div>
      </div>
    </div>
  );
};

export default ViewSubAdmin;
